import { useEffect, useRef } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActivePage } from "../features/navigation/navigationSlice";
import { ROUTE_TO_PAGE_NAME } from "../constants/routeUrls";
import { trackRouteChange } from "./telemetryClient";

const RouteWatcher = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const prevPathRef = useRef(null);

  useEffect(() => {
    const path = `${location.pathname}${location.search || ""}`;
    for (const { pattern, pageName } of ROUTE_TO_PAGE_NAME) {
      if (matchPath(pattern, location.pathname)) {
        dispatch(setActivePage(pageName));
        break;
      }
    }
    trackRouteChange(path, prevPathRef.current || undefined);
    prevPathRef.current = path;
  }, [location, dispatch]);

  return null;
};

export default RouteWatcher;
